import RankChangeRenderer from '@/app/common/components/CellRenderers/RankChangeRenderer';
import { errorMessage, successMessage } from '@/utils/toast';
import { AiOutlineZoomIn } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import countSuffix from '@/helpers/countSuffix';
import { updateTransaction } from '@/app/common/components/ag-grid/updateTransaction';

export const tagsColumnConfig = (
  domain_slug,
  domain,
  editTag,
  path,
  gridRef
) => [
  {
    field: 'title',
    type: 'string',
    title: 'عنوان برچسب',
    flex: 1,
    editable: true,
    valueSetter: params => {
      editTag({
        tag_id: params.data.id,
        domain_slug,
        title: params.newValue
      })
        .unwrap()
        .then(res => {
          updateTransaction(res?.data, gridRef);
          successMessage('برچسب با موفقیت ویرایش شد');
          return true;
        })
        .catch(err => {
          errorMessage('خطایی در ویرایش برچسب وجود دارد');
          console.error(err);
          return true;
        });
    },
    minWidth: 300,
    searchable: true
  },
  {
    field: 'num_of_keywords',
    type: 'number',
    title: 'تعداد کلمات',
    width: 130,
    searchable: true,
    cellRenderer: params => {
      return params.data.num_of_keywords !== 0 ? (
        <Link
          to={`/keyword-tracker/keywords/${domain_slug}/${domain}?FByTags=[and,equals,${params.data.id}]`}
          className="d-flex align-items-center gap-1  h-100"
        >
          <AiOutlineZoomIn icon="search-plus" className="cursor-pointer fs-0" />
          <span>{params.data.num_of_keywords}</span>
        </Link>
      ) : (
        0
      );
    }
  },
  {
    field: 'total_search_volume_miztols',
    type: 'number',
    title: 'میزان جستجو',
    width: 130,
    searchable: true
  },
  {
    field: 'average_rank',
    type: 'number',
    title: 'میانگین ',
    width: 100,
    gp: 'رتبه',
    searchable: true
  },
  {
    field: 'change_average_rank',
    type: 'number',
    gp: 'رتبه',
    title: 'تغییر',
    cellRenderer: params => <RankChangeRenderer change={params.value} />,
    width: 100,
    searchable: true
  },

  {
    field: 'total_sov',
    type: 'number',
    title: 'SOV کل',
    width: 100,
    searchable: true,
    cellRenderer: ({ value }) => countSuffix(value)
  }
];
